import React, { Component } from 'react';

export default class B1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			PAerror: false
		}
	}

	checkPA(PA) {
		if (!(/\d{11}/gm.test(PA)) || PA.length != 11) {
			this.setState({ PAerror: 'Invalid Entry' })
		}
	}

	cancelPA = (e) => {
		if (!(/\d{11}/gm.test(this.props.data.PANumber)) || this.props.data.PANumber.length != 11) {
			this.setState({ PAerror: 'Invalid Entry' })
		} else {
			fetch(window.location.origin + window.location.pathname + 'cancelpa', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify(this.props.data) }).then((response) => {
				response.text().then((page) => {
					this.props.navigate(page)
				})
			})
		}
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Cancel a Prior Authorization</h3>
				<hr />
				<p>Enter the Prior Authorization number you wish to cancel:</p>
				<input type="text" value={this.props.data.PANumber} onBlur={() => { this.checkPA(this.props.data.PANumber) }} onChange={(e) => { this.props.setData('PANumber', e.currentTarget.value); this.setState({ PAerror: false }) }} />
				{this.state.PAerror ? <div className="error">{this.state.PAerror}</div> : ''}

				<div className="button" style={this.props.data.PANumber ? {} : { backgroundColor: '#888' }} onClick={this.cancelPA}>Continue</div>
			</div>
		);

	}
}